/**
 * Create a query string from specified get parameters.
 * @param filter Key value pair of get parameters.
 */
export function resolveQueryString(filter) {
    const queryString = Object.entries(filter)
        .filter(([, value]) => value !== undefined)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`)
        .join('&');
    return queryString ? `?${queryString}` : '';
}
//# sourceMappingURL=resolveQueryString.js.map